import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import Toggle from "../../../ui/molecules/toggle"
import { EditIcon } from "../../../ui/icons/edit"
import { headQuarterResponseDataDTO } from "../dto"
import { TrashIcon } from "../../../ui/icons/trash"
import { Alert } from "../../../ui/organisms/alert"
import Button from "../../../ui/molecules/button"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { GetHeadQuarter, resetSotCreationStatus, resetSotDeleteStatus, resetSotRemoveStatus, resetSotRestoreStatus, resetSotUpdateStatus, setOnEdit, setSotIdToUpdate, setSotUpdateAddress, setSotUpdateCity, setSotUpdateCode, setSotUpdateEmail, setSotUpdateFax, setSotUpdateManager, setSotUpdateName, setSotUpdatePec, setSotUpdatePhone, setSotUpdateProvince, setSotUpdateRegion, setSotUpdateZipcode, SOTDelete, SOTRemove, SOTRestore } from "../slice"
import { SOTPopupEdit } from "./popup"

export function SOTList() {
    const dispatch = useAppDispatch()
    const sotState = useAppSelector(state => state.headQuarter)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const [sotToDelete, setSOTToDelete] = useState<headQuarterResponseDataDTO | null>(null)

    const onEditHandle = (sot: headQuarterResponseDataDTO) => {
        dispatch(setSotIdToUpdate(sot.id))
        dispatch(setSotUpdateManager(sot.manager))
        dispatch(setSotUpdatePhone(sot.phone))
        dispatch(setSotUpdateFax(sot.fax))
        dispatch(setSotUpdateEmail(sot.email))
        dispatch(setSotUpdatePec(sot.pec))
        dispatch(setSotUpdateName(sot.name))
        dispatch(setSotUpdateCode(sot.code))
        dispatch(setSotUpdateRegion(sot.region))
        dispatch(setSotUpdateAddress(sot.address))
        dispatch(setSotUpdateZipcode(sot.zipCode))
        dispatch(setSotUpdateCity(sot.city))
        dispatch(setSotUpdateProvince(sot.province))
        dispatch(setOnEdit(true))
        setShowPopup(true)
    }

    useEffect(() => {
        dispatch(GetHeadQuarter(sotState.sotFilters))
    }, [])

    useEffect(() => {
        if(sotState.sotCreationStatus === 'successfully') {
            dispatch(resetSotCreationStatus())
            setShowSuccess(true)
            dispatch(GetHeadQuarter(sotState.sotFilters))
        }

        if(sotState.sotUpdateStatus === 'successfully') {
            dispatch(resetSotUpdateStatus())
            setShowSuccess(true)
            dispatch(GetHeadQuarter(sotState.sotFilters))
        }

        if(sotState.sotRemoveStatus === 'successfully') {
            dispatch(resetSotRemoveStatus())
            dispatch(GetHeadQuarter(sotState.sotFilters))
        }

        if(sotState.sotRestoreStatus === 'successfully') {
            dispatch(resetSotRestoreStatus())
            dispatch(GetHeadQuarter(sotState.sotFilters))
        }

        if(sotState.sotDeleteStatus === 'successfully') {
            dispatch(resetSotDeleteStatus())
            setShowSuccess(true)
            dispatch(GetHeadQuarter(sotState.sotFilters))
        }
    }, [sotState.sotCreationStatus,
        sotState.sotUpdateStatus,
        sotState.sotRemoveStatus,
        sotState.sotRestoreStatus,
        sotState.sotDeleteStatus
    ])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div className="w-[100%] flex flex-col gap-[16px] filter bg-brandPrimary-200" style={{ flex: 0.7, padding: '0px 24px 24px 24px', borderTopRightRadius: '20px' }}>
            <div className="w-[100%]">
                {
                    (showSuccess) &&

                    <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                        <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                            Dati salvati correttamente.
                        </span>
                    </div>
                }
                <div style={{ padding: '24px 0' }}>
                    <table id="users-table" className="w-full table-fixed">
                        <thead className="h-[52px] uppercase">
                            <tr>
                                <th className="w-[100px]">Codice</th>
                                <th className="w-[100px]">Nome</th>
                                <th className="w-[100px]">Pec</th>
                                <th className="w-[100px]">Email</th>
                                <th className="w-[100px]">Telefono</th>
                                <th className="w-[70px]">Regione</th>
                                <th className="w-[100px]">Provincia</th>
                                <th className="w-[100px]">Città</th>
                                <th className="w-[100px]">CAP</th>
                                <th className="w-[100px]">Indirizzo</th>
                                <th className="w-[100px]">Manager</th>
                                <th className="w-[100px]">Fax</th>
                                <th className="w-[70px]">Attivo</th>
                                <th className="w-[60px]" style={{ borderTopRightRadius: '8px' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {sotState.responseHeadQuarter?.data.map((sot, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        color: '#4D797F',
                                        background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                    }}
                                >
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '150px' }}>{sot.code}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '150px' }}>{sot.name}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '150px' }}>{sot.pec}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '150px' }}>{sot.email}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '150px' }}>{sot.phone}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '150px' }}>{sot.region}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '150px' }}>{sot.province}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '150px' }}>{sot.city}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '150px' }}>{sot.zipCode}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '170px' }}>{sot.address}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '170px' }}>{sot.manager}</td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '170px' }}>{sot.fax}</td>
                                    <td>
                                        <Toggle
                                            checked={sot.deletedAt === null}
                                            onChange={(value) =>
                                                value
                                                    ? dispatch(SOTRestore(sot.id!))
                                                    : dispatch(SOTRemove(sot.id!))
                                            }
                                        />
                                    </td>
                                    <td className="whitespace-normal break-words" style={{ maxWidth: '100px' }}>
                                        <div className="flex justify-content-between align-items-center gap-[8px]">
                                            <button onClick={() => onEditHandle(sot)}>
                                                <EditIcon color={"Orange"} size={18} />
                                            </button>
                                            <div className="flex align-items-center">
                                                <button onClick={() => {
                                                    setSOTToDelete(sot)
                                                    setShowAlert(true)
                                                }}>
                                                    <TrashIcon color={"Orange"} size={0} />
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {
                (showAlert && sotToDelete) && (
                    <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3">
                                <div>
                                    Sei sicuro di voler eliminare il sot?
                                </div>
                                <div className="mt-3 font-bold">
                                    {`${sotToDelete.name} - [${sotToDelete.code}]`}
                                </div>
                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />
                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color="orange"
                                        iconPosition="off"
                                        label="Elimina"
                                        size="md"
                                        onClick={() => {
                                            dispatch(SOTDelete(sotToDelete.id!))
                                            setShowAlert(false)
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
            {
                showPopup && (
                    <PopupForm title="Modifica SOT" close={() => setShowPopup(false)}>
                        <SOTPopupEdit close={() => setShowPopup(false)} />
                    </PopupForm>
                )
            }
        </div>
    )
}